import React, { Component } from 'react';
import {Grid, Typography} from "@material-ui/core";
import style from "./style";


export default class CustomCenterHeader extends Component {
	render () {
		return (
			<Grid container style={style.parentContainer}>
				{this.props.computer && <Typography variant='h4' style={style.setFont} gutterBottom align="center">
					<div dangerouslySetInnerHTML={{
						__html: this.props.text
					}} />
				</Typography>}
				{this.props.mobile && <Typography variant='h6' style={style.setFont} gutterBottom align="center">
					{this.props.text}
				</Typography>}
			</Grid>
		);
	}
}
